import React from "react";
import "./style.scss"

import {buildStyles, CircularProgressbarWithChildren,} from "react-circular-progressbar";

import {Image} from "react-bootstrap";
import {ReactComponent as StarIcon} from "../../../asset/icons/starIcon.svg";
import {ReactComponent as EmptyStarIcon} from "../../../asset/icons/emptyStarIcon.svg";
import ReactStars from "react-rating-stars-component";
import avatar from "../../../asset/image/avatar.png";

import Smallscore from "../../../asset/image/score-small.png";
import Bigscore from "../../../asset/image/score-big.png";
import {useTranslation} from "react-i18next";


export default function Details({money, coins}) {

  const [completeProfile, setComleteProfile] = React.useState(50);
  const {t} = useTranslation()

  return (
    <div className="wallet-details-container">
      <div className="info-card-dash">
        <div className="avatar-section">
          <div className="avatar-image">
            <div className="avatar-border"></div>
            <CircularProgressbarWithChildren
              value={completeProfile}
              counterClockwise
              strokeWidth={4}
              styles={buildStyles({
                strokeLinecap: "butt",
              })}
            >
              <Image src={avatar} alt="avatar"/>
            </CircularProgressbarWithChildren>
          </div>
        </div>
        <div className="name">نیما کفش آرا</div>
        <div className="rating-stars">
          <ReactStars
            edit={false}
            value={5}
            count={5}
            size={24}
            activeColor="#FEB730"
            filledIcon={<StarIcon/>}
            emptyIcon={<EmptyStarIcon/>}
          />
        </div>
        <div className="wallet-cash">
          <p>{t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.WalletBalance.Label')}</p>
          <div>
            <span>{money}</span>
            <span>تومان</span>
          </div>
        </div>
        <div className="wallet-score">
          <Score size={"large"} score={5} title={true} coins={coins}/>
        </div>
        <button className="score-btn">
          {t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.AchievePoints.Button')}
        </button>
      </div>
    </div>
  )
}

function Score({size, score, title, coins}) {
  let count = 0;
  const finalScore = [];
  for (count; count < score; count++) {
    finalScore.push(
      <img src={size === "small" ? Smallscore : Bigscore} alt="score"/>
    );
  }

  return (
    <div className="score">
      <div style={{display: title === true ? "block" : "none"}}>
        {coins}
      </div>
      <div className="score-coins">{finalScore}</div>
    </div>
  );
}

